import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'

export const C1TabTheme: Components<Theme>['MuiTab'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            mx: 0,
            textTransform: 'none',
            px: 2,
            py: 0,
            minHeight: '32px',
            fontSize: '14px',

            '&:hover': {
                backgroundColor: 'primary.extraLight',
                color: 'primary.dark',
                borderTopLeftRadius: C1BorderRadius.regular,
                borderTopRightRadius: C1BorderRadius.regular,
            },

            '&:focus-visible': {
                backgroundColor: 'primary.extraLight',
                color: 'primary.dark',
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: '-2px',
                borderTopLeftRadius: C1BorderRadius.regular,
                borderTopRightRadius: C1BorderRadius.regular,
            },

            '&.Mui-selected': {
                color: 'primary.main',
                fontWeight: 500,
            },
        }),
        disabled: ({ theme }) => theme.unstable_sx({
            color: 'grey.600',
        }),
    },
}

export const C1TabsTheme: Components<Theme>['MuiTabs'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            minHeight: '32px',
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: 'border.subtle',

            '& .MuiTabs-indicator': {
                height: 3,
                backgroundColor: 'transparent',
                justifyContent: 'center',
                display: 'flex',

                '& > span': {
                    width: '100%',
                    backgroundColor: 'primary.main',
                },
            },
        }),
    },
}
